import './styles.scss';

import { useEffect, useState } from 'react';
import FavoriteStore from './FavoriteStore';
import { isAppPWA } from '../../../utils/helper-functions';
import { HOME } from '../../../constants/routes';
import { useNavigate } from 'react-router-dom/dist';

const SetAccountScreen = () => {
  // state
  const [activeTab, setActiveTab] = useState(1);
  const isPWA = isAppPWA();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isPWA) navigate(HOME);
  }, []);

  return (
    <div className="absolute flex flex-col w-screen h-full overflow-hidden set-account-screen">
      <div className="tabs mb-[4.5rem]">
        <div className={activeTab >= 1 ? 'active' : ''} />
        <div className={activeTab >= 2 ? 'active' : ''} />
        {/* <div className={activeTab >= 3 ? "active" : ""} /> */}
      </div>
      {activeTab === 1 && <FavoriteStore setActiveTab={setActiveTab} />}
    </div>
  );
};

export default SetAccountScreen;
